export default __webpack_public_path__ + "static/media/selecta_main_small.a522e5e1.jpg";